import { Download, RefreshCw, X } from "lucide-react";
import { usePwa } from "@/lib/pwa";

export const UpdateBanner = () => {
  const pwa = usePwa();
  if (!pwa?.updateReady) return null;
  return (
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-[60] bg-[var(--navy)] text-white rounded-full shadow-lg px-4 py-2 flex items-center gap-3 text-sm" data-testid="update-banner">
      <RefreshCw className="w-4 h-4 text-[var(--aqua)]" />
      <span>A new version is available.</span>
      <button onClick={pwa.applyUpdate} className="bg-[var(--red)] px-3 py-1 rounded-full font-semibold" data-testid="update-refresh">Refresh</button>
    </div>
  );
};

export const InstallButton = ({ className = "", variant = "light" }) => {
  const pwa = usePwa();
  if (!pwa?.canInstall) return null;
  const styles = variant === "dark"
    ? "bg-white/10 hover:bg-white/20 text-white"
    : "bg-[var(--action)] hover:bg-[var(--bright)] text-white";
  return (
    <button onClick={pwa.install} data-testid="install-button"
      className={`inline-flex items-center justify-center gap-2 font-semibold rounded-full px-4 py-2 text-sm btn-lift ${styles} ${className}`}>
      <Download className="w-4 h-4" /> Install Veterans PWC
    </button>
  );
};
